export default __webpack_public_path__ + "static/media/MainIcon3.6615c18b.svg";